import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";

import {
  MasksFormContextProvider,
  MasksContextProvider,
  TaskContextProvider,
  TasksContextProvider,
} from "../providers";

import { PATH_ROUTES } from "./routes";

import { Home, ProfessionsRegulades, ProfessionalsSanitaris, OfertaUniversitaria, DesajustTitulacio, Login, DocumentsViewer, WhiteList } from "../pages";

import ProtectedRoute from "./ProtectedRoute";

const routes = createBrowserRouter([
  {
    path: PATH_ROUTES.login,
    element: <Login />,
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: PATH_ROUTES.home,
        element: (
          <TasksContextProvider>
            <Home />
          </TasksContextProvider>
        ),
      },
      {
        path: PATH_ROUTES.professionsRegulades,
        element: (
          <TasksContextProvider>
            <ProfessionsRegulades />
          </TasksContextProvider>
        ),
      },
      {
        path: PATH_ROUTES.professionalsSanitaris,
        element: (
          <TasksContextProvider>
            <ProfessionalsSanitaris />
          </TasksContextProvider>
        ),
      },
      {
        path: PATH_ROUTES.ofertaUniversitaria,
        element: (
          <TasksContextProvider>
            <OfertaUniversitaria />
          </TasksContextProvider>
        ),
      },
      {
        path: PATH_ROUTES.desajustTitulacio,
        element: (
          <TasksContextProvider>
            <DesajustTitulacio />
          </TasksContextProvider>
        ),
      },
      {
        path: PATH_ROUTES.documentsViewer,
        element: (
          <TaskContextProvider>
            <MasksFormContextProvider>
              <MasksContextProvider>
                <DocumentsViewer />
              </MasksContextProvider>
            </MasksFormContextProvider>
          </TaskContextProvider>
        ),
      },
      {
        path: PATH_ROUTES.whiteList,
        element: (
          <WhiteList />
        ),
      }
    ],
  },
  { path: "*", element: <Navigate to={PATH_ROUTES.home} /> }, // Si no es una ruta correcta redirigimos a la HOME
]);

const Router = () => {
  return <RouterProvider router={routes} />;
};

export default Router;
